import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import iconArrowDown from "../../../img/icons/arrow_down.svg";
import { SortType } from "../../models/tempur-love-grid";

import styles from "./index.module.scss";

// dangerouslySetInnerHTML is omitted because Immutable<> strips the nominal
// brand from TrustedHTML, making the spread below unassignable to <select>
// props (and a sort dropdown should never accept injected HTML anyway).
type Props = Immutable<
    Omit<
        React.SelectHTMLAttributes<HTMLSelectElement>,
        "value" | "dangerouslySetInnerHTML"
    > & {
        value: SortType;
    }
>;

export const SortDropdown = (props: Props): React.JSX.Element => {
    const sortNames: { [K in SortType]: string } = {
        "-date": t`Newest`,
        "date": t`Oldest`,
    };
    const sortMapping = Object.entries(sortNames);
    return (
        <section className="search-select">
            <div className="search-select__sort">
                <label className="search-select__label" htmlFor="sort-by">
                    {t`Sort by:`}
                </label>
                <select
                    className="search-select__form-select"
                    {...props}
                    id="sort-by"
                >
                    {sortMapping.map(([value, display]) => (
                        <option key={value} value={value}>
                            {display}
                        </option>
                    ))}
                </select>
                <SVG
                    src={iconArrowDown}
                    className={concatClassNames([
                        styles.sortIcon,
                        "search-select__icon",
                    ])}
                    role="presentation"
                />
            </div>
        </section>
    );
};
